module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "760px",
      "height": "570px"
    }
  }, [(_vm.ofd_detail.url && _vm.ofd_detail.url.indexOf('ofd') != -1) ? _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "100%"
    }
  }, [(_vm.ofd_detail.is_place && _vm.ofd_detail.is_place == 2) ? _c('img', {
    staticClass: "yiguidang",
    attrs: {
      "src": require("../../assets/images/zhang1.gif")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ofd_detail.is_really && _vm.ofd_detail.is_really == 1) ? _c('img', {
    staticClass: "yiguidang",
    attrs: {
      "src": require("../../assets/images/zhang4.gif")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "#ccc 1px solid"
    },
    attrs: {
      "id": 'ofd_content',
      "width": "100%"
    }
  }, [_c('div', {
    class: 'seal_img_div'
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d8ea745!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/ofd.vue
// module id = 1833
// module chunks = 2